module.exports = __webpack_public_path__ + "toBride1-we-w-b.39c81060.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-w-b.jpg
// module id = WSAs
// module chunks = 0